import axios from 'axios'
import store from '../store'
import { itemscollection, activecollection, renewitems, renewcollection, chartdataxy, chartdatagroup } from "@/components/utility/indexdb";
import { getparamsfromstore, searchinfo, extractinfofromtxt,tomakeurl } from "./objparamobj"


var fetchdata = function (datesort) {
    return new Promise(resolve => {

        //如果是generalsearch，那么对targettxt中的信息进行检查提取
        if (store.state.searchmodel == "generalsearch") {
            extractinfofromtxt()
        }

        let thesearchmodel = store.state.searchmodel
        let query = getparamsfromstore(thesearchmodel)
        //console.log(query)
        
        //将请求参数生成url,并存入history
        if(!["splitfield", "apisearch"].includes(store.state.searchmodel)){
            axios.generateurl(query)
        }
        

        //fetch数据
        axios.post(url + thesearchmodel, query, { responseType: "json" })
            .then(res => {

                //apisearch及splitfield完成后，恢复为generalsearch
                if (["splitfield", "apisearch"].includes(store.state.searchmodel)) {
                    store.commit("setsearchmodel", "generalsearch")
                }

                //在搜索框显示搜索信息
                searchinfo(thesearchmodel)
                console.log(res)
                let resdata = res.data

                let datainformation = { perpage: resdata.perpage, totalresults: resdata.totalresults }

                let x = {};
                x.collection = resdata.collection;
                x.header = resdata.fields;
                activecollection("headers")
                    .remove({ collection: resdata.collection })
                    .then(() => {
                        //indexdb储存表头
                        activecollection("headers").insert(x)
                            .then(
                                () => {
                                              
                                    //collection设置（仅在请求的clct与返回clct不一致的时设置，也即数据库跳转了，这目前适用于splitfield）
                                    if (store.state.clct != resdata.collection) {
                                        //这里之所以采用reload重新加载，因为report可能是第一次生成，在collections中可能不存在
                                        window.location.href=tomakeurl({collection:resdata.collection,target:""},"generalsearch")
                                        location.reload()
                                        // axios.clctinitial.clctinitiate(resdata.collection)
                                        //     .then(() => {
                                        //         store.commit("setitems", res.data.doc)
                                        //         store.commit("setdatainformation", datainformation)
                                        //     })
                                    }
                                    else {
                                 
                                        store.commit("setcurrentheader", resdata.fields);
                                        store.commit("setitems", res.data.doc)
                                        store.commit("setdatainformation", datainformation)
                                    }
                                  
                                    resolve("done")
                                    if (resdata.doc.length > 0) {
                                        //indexdb储存数据
                                        renewcollection(resdata.doc)
                                            .then(docs => {

                                                if (datesort) {//如果是datesort 那么显示时间图表
                                                    axios.fetchremotechartdata("time")
                                                }
                                                else {
                                                    //生成图表
                                                    generatechart()
                                                }

                                            })
                                        // })

                                    }
                                    // })



                                }

                            )
                    });

            })

    })

}





function generatechart() {

    //检查x是否为string
    let checkx = store.state.xfields.find(obj => {
        return obj.name === store.state.xfield;
    });
    //如果不为string，那么取string值作为x轴
    let xval = checkx ? store.state.xfield : store.state.xfields[0].name;

    store.commit("setxfield", xval);
    chartdataxy(store.state.xfield, store.state.yvalues)
        .then(doc => {
            chartdatagroup(store.state.xfield, store.state.yvalues, doc)
        })
}


// export default fetchdata
export { fetchdata }


// WEBPACK FOOTER //
// ./src/axios/fetchdata.js